import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, X } from 'lucide-react';

interface PendingLessonRowProps {
  onCommit: (lesson: string) => void;
  onCancel: () => void;
}

export function PendingLessonRow({
  onCommit,
  onCancel,
}: PendingLessonRowProps) {
  const { t } = useTranslation('debriefV2');
  const [draft, setDraft] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, [draft]);

  return (
    <div className="flex items-start gap-2.5 w-full bg-white border border-indigo-300 shadow-sm rounded-lg p-3 ring-2 ring-indigo-500/20 transition-all group">
      <div className="shrink-0 mt-0.5">
        <CheckCircle2
          className="h-[18px] w-[18px] text-emerald-500 fill-emerald-50"
          aria-hidden
        />
      </div>
      <textarea
        ref={textareaRef}
        rows={2}
        value={draft}
        placeholder={t('lessons.lessonPlaceholder')}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={() => onCommit(draft)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            onCancel();
          }
        }}
        className="flex-1 text-sm text-slate-900 placeholder:text-slate-400 bg-transparent outline-none resize-none overflow-hidden"
      />
      <button
        type="button"
        onMouseDown={(event) => {
          event.preventDefault();
          onCancel();
        }}
        className="shrink-0 text-slate-300 hover:text-red-500 transition-colors p-0.5"
        aria-label={t('lessons.cancelLessonAria')}
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
}
